<template>
  <transition mode="out-in" appear @enter="enter" @leave="leave" :css="false">
    <section class="showcase2nd">
      <div class="showcase2nd__bg" data-move-standard data-move data-speed="5">
        <div class="showcase2nd__bg-view">
          <video
            id="showcaseEnterVideo"
            src="https://vod.plaync.com/LineageW/Showcase2_Transition.mp4"
            muted
            playsinline
          />
          <video
            id="showcaseLoopVideo"
            src="https://vod.plaync.com/LineageW/Showcase2_Loop.mp4"
            muted
            playsinline
            loop
            style="opacity: 0"
          />
        </div>
        <div class="showcase2nd__btns" :style="'width:' + imgWidth + 'px'">
          <a
            href="javascript:;"
            class="showcase2nd__btns-area2"
            @click="showYoutube(0)"
          >
            <span>{{ $t("showcase2nd.spot-2.title") }}</span>
          </a>
          <a
            href="javascript:;"
            class="showcase2nd__btns-area3"
            @click="showYoutube(1)"
          >
            <span>{{ $t("showcase2nd.spot-1.title") }}</span>
          </a>
          <router-link to="/event/teasing/showcase" class="showcase2nd__btns-area4" >{{ $t("showcase2nd.spot-3.title") }}</router-link>
          <a :href="getPreorderURL" target="blank" class="showcase2nd__btns-area5">
            <span>{{ $t("showcase2nd.spot-4.title") }}</span>
          </a>
          
          <a href="/preorder/character/210930/index/" target="blank" class="showcase2nd__btns-area1">
            <span>{{ $t("showcase2nd.spot-5.title") }}</span>
          </a>
        </div>
      </div>

      <FrameBook></FrameBook>
      <div class="showcase2nd__contents">
        <div class="showcase2nd__txt">
          <div class="showcase2nd__txt-subbg"></div>
          <div class="showcase2nd__txt-bg"></div>
          <div class="showcase2nd__txt-bl">
            <span class="bl--1"></span><span class="bl--2"></span
            ><span class="bl--3"></span>
            <hr class="bl--r" />
            <hr class="bl--l" />
          </div>
          <div class="showcase2nd__txt-tit" v-html="$t('showcase2nd.tit')"></div>
          <div class="showcase2nd__txt-desc" v-html="$t('showcase2nd.desc')"></div>
        </div>
      </div>
      <ScrollBtn></ScrollBtn>
      <div v-if="isMobile" class="showcase2nd__drag-info">
        {{ $t("showcase2nd.drag-msg") }}
      </div>
    </section>
  </transition>
</template>

<script>
import BaseSection from "./mixins/BaseSection.js";
import { mapState, mapGetters } from "vuex";
import gsap from "gsap";
import FrameBook from "@/components/FrameBook";
import promokit from "@/utils/promokit";
import ScrollBtn from "../components/ScrollBtn";

export default {
  name: "showcase2nd",
  components: { FrameBook, ScrollBtn },
  mixins: [BaseSection],
  data() {
    return {
      name: "showcase2nd",
      bg: null,
      loopVideo: null,
      titMotion: null,
      imgWidth: 1920,
      youtubeLayerData: {
        0: {
          youtubespot: {
            ko: "xO-9J4hPQZA",
            en: "VerUzJXMWEU",
            ja: "UC6QDp4HJ78",
            zh: "ZBGlx2tqIzg",
          },
          layertit: {
            ko: "리니지W 2nd 쇼케이스",
            en: "Lineage W's 2nd Showcase",
            ja: "リネージュW 2ndオンライン発表会",
            zh: "天堂W 2nd 展示會",
          },
        },
        1: {
          youtubespot: {
            ko: "tnGhyuyGqT0",
            en: "Pmt3tms9HdI",
            ja: "rairh_out50",
            zh: "UC6QDp4HJ78",
          },
          layertit: {
            ko: "시네마틱 트레일러 II",
            en: "Cinematic Trailer II",
            ja: "シネマティック トレーラーⅡ",
            zh: "預告影集Ⅱ",
          },
        },
      },
    };
  },
  computed: {
    ...mapState(["lang"]),
    ...mapGetters(["getPreorderURL"]),
  },
  methods: {
    note(){
      if(this.lang === 'ko'){
        alert('11시부터 참여 가능합니다')
      }else if(this.lang === 'en'){
        alert('Available from 11AM')
      }else if(this.lang === 'ja'){
        alert('11時から参加可能です')
      }else if(this.lang === 'zh'){
        alert('活動將於11點（KST）開始')
      }
    },
    setMotion() {
      this.enterMotion = new gsap.timeline({
        paused: true,
        onStart: () => {
          this.setIsMovePage(true);
        },
      });
      this.enterMotion
        .addLabel("start")
        .from(this.$el, 0.5, { opacity: 0, ease: "power2.easeOut" });
      this.titMotion = new gsap.timeline({ paused: true });

      this.titMotion
        .addLabel("title")
        //.to(this.$el.querySelector(`.coming__bg-img`), 3,{ autoAlpha:1}, 'title')
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--1`),
          0.4,
          { autoAlpha: 0, rotation: 190 },
          { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--2`),
          0.4,
          { autoAlpha: 0, rotation: -190 },
          { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--3`),
          0.4,
          { autoAlpha: 0, scale: 3 },
          { autoAlpha: 1, scale: 1, ease: "Back.easeOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--r`),
          0.4,
          { autoAlpha: 0, x: -30, y: -5 },
          { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--l`),
          0.4,
          { autoAlpha: 0, x: 30, y: -5 },
          { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-bg`),
          0.4,
          { autoAlpha: 0, y: -10 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-tit`),
          0.4,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.4"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-subbg`),
          0.4,
          { autoAlpha: 0, y: -30 },
          { autoAlpha: 0.4, y: 0, ease: "expo.easeOut" },
          "title+=0.6"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-desc`),
          0.4,
          { autoAlpha: 0, y: -30 },
          { autoAlpha: 0.4, y: 0, ease: "expo.easeOut" },
          "title+=0.6"
        )
        .fromTo(
          this.$el.querySelector(`.scroll-btn`),
          0.5,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.2"
        )
        .set(
          this.$el.querySelector(`.${this.name}__btns`),
          { display: "block" },
          "title"
        )
        .fromTo(
          this.$el.querySelectorAll(`.${this.name}__btns > a`),
          0.5,
          { autoAlpha: 0 },
          { autoAlpha: 1, ease: "expo.easeOut", stagger: 0.05 },
          "title+=0.2"
        );

      if (this.isMobile) {
        this.titMotion
          .fromTo(
            this.$el.querySelector(`.${this.name}__drag-info`),
            0.3,
            { autoAlpha: 0 },
            { autoAlpha: 1, ease: "expo.easeOut" },
            "title+=0.5"
          )
          .to(
            this.$el.querySelector(`.${this.name}__drag-info`),
            { autoAlpha: 0, display: "none" },
            "title+=2"
          );
      }
    },
    leave(el, done) {
      gsap.to(this.$el, 0.5, { opacity: 0, onComplete: done });
    },
    enter(el, done) {
      this.setMotion();
      this.enterMotion.eventCallback("onComplete", () => {
        done();
        this.setIsMovePage(false);
      });
      if (this.currentPage == "index") this.autoPlay = false;
      this.setCurrentPage(this.name);
      this.setEnterPage(this);
    },
    start() {
      const video = document.querySelector("#showcaseEnterVideo");

      video.addEventListener("ended", (event) => {
        this.loopVideo = document.querySelector("#showcaseLoopVideo");
        gsap.to(this.loopVideo, 0.2, {
          opacity: 1,
          onComplete: () => {
            video.remove();
            this.setIsMovePage(false);
          },
        });
        this.loopVideo.play();
        this.imgWidth = this.loopVideo.offsetWidth;
        this.titMotion.play();
      });
      video.play();

      this.enterMotion.play();
    },
    showYoutube(turn) {
      let player = [];
      let slickOption = {
        arrows: true,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: turn,
      };
      const youtubeLayerDataLangth = 2;
      let titList = [];

      const parseRange = document.createRange();
      const parse = Range.prototype.createContextualFragment.bind(parseRange);
      let layerEle = `<div id="videoLayer">`;

      for (let i = 0; i < youtubeLayerDataLangth; i++) {
        layerEle += `
          <div id="videoPlayer${i}" class="videoPlayerMedia">
          
          </div>
          `;
      }
      layerEle += `</div>`;
      document.querySelector("body").appendChild(parse(layerEle));

      for (let i = 0; i < youtubeLayerDataLangth; i++) {
        const isPlay = i == turn ? true : false;
        player[i] = promokit.youtube({
          el: "#videoPlayer" + i,
          youtubeid: this.youtubeLayerData[i].youtubespot[this.lang],
          controls: true,
          autoPlay: isPlay,
          mute: false,
        });
      }

      const layer = promokit.layer({
        el: "#videoLayer",
        render: true,
        autoplayVideo: player[turn],
      });

      $("#videoLayer")
        .slick(slickOption)
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          player[currentSlide].pause();
          titList[currentSlide].style.opacity = 0;
        })
        .on("afterChange", function (event, slick, currentSlide, nextSlide) {
          player[currentSlide].play();
          titList[currentSlide].style.opacity = 1;
        });

      layer.open();
      layer.on("closeend", () => {
        document.querySelector(".promokit-layer").remove();
      });

      $(".promokit-layer").addClass("showcase-layer");

      for (let i = 0; i < youtubeLayerDataLangth; i++) {
        let spanTit = document.createElement("span");
        spanTit.className = "youtube-title";
        let text = document.createTextNode(
          this.youtubeLayerData[i].layertit[this.lang]
        );
        spanTit.appendChild(text);
        document.querySelector("#videoLayer").appendChild(spanTit);
      }

      titList = document.querySelectorAll(".youtube-title");
      titList[turn].style.opacity = 1;
    },
  },
  mounted() {
    if (this.autoPlay) {
      this.start();
      this.setIsIntro(false);
    }
    this.bg = this.$el.querySelector(".showcase2nd__bg");
    this.$watch(
      "documentSize",
      (val) => {
        let w, h, left;
        const r = val.h / val.w;
        const rh = val.w / val.h;
        const vr = 1080 / 1920;
        const vrh = 1920 / 1080;

        if (val.h < val.w) {
          if (r > 0.5625) {
            h = val.h;
            w = h * vrh;
            left = (w - val.w) / 2;
          } else {
            w = val.w * 1;
            h = w * 0.5625;
            left = 0;
          }
        } else {
          if (rh >= 0.5625) {
            h = val.h;
            w = val.h * r;
            left = (w - val.w) / 2;
          } else {
            h = val.h;
            w = val.h * 1.78;
            left = (w - val.w) / 2;
          }
        }
        this.bg.style.width = w + "px";
        this.bg.style.height = h + "px";
        this.bg.style.left = -left + "px";

        if (this.loopVideo) this.imgWidth = this.loopVideo.offsetWidth;
      },
      { immediate: true }
    );
  },
};
</script>

<style lang="scss">
:lang(en) {
  .showcase2nd {
    &__txt {
      &-tit {
        @include bg($bg: "../assets/img/en/showcase2nd_tit_en.png");
        @include bp(tablet) {
          @include bg($bg: "../assets/img/en/showcase2nd_tit_en_m.png");
        }
      }
    }
    &__btns {
      a {
        @include bp(tablet) {
          width: 266px;
          height: 266px;
        }

        @include bg($bg: "../assets/img/en/btn_showcase2nd_pc_en.png");

        &:before {
          @include bg($bg: "../assets/img/en/btn_showcase2nd_pc_en.png");
        }
      }

      &-area1 {
        @include bp(tablet) {
          background-image: url("../assets/img/en/btn_showcase2nd_m_en_1.png") !important;
        }
        &::before {
          background-position: -238px 9px !important;
        }
      }
      &-area2 {
        @include bp(tablet) {
          background-image: url("../assets/img/en/btn_showcase2nd_m_en_2.png") !important;
        }
        &::before {
          background-position: -237px -231px !important;
        }
      }
      &-area3 {
        @include bp(tablet) {
          background-image: url("../assets/img/en/btn_showcase2nd_m_en_3.png") !important;
        }
        &::before {
          background-position: -234px -470px !important;
        }
      }
      &-area4 {
        @include bp(tablet) {
          background-image: url("../assets/img/en/btn_showcase2nd_m_en_4.png") !important;
        }
        &::before {
          background-position: -238px -690px !important;
        }
      }
      &-area5 {
        @include bp(tablet) {
          background-image: url("../assets/img/en/btn_showcase2nd_m_en_5.png") !important;
        }
        &::before {
          background-position: -237px -912px !important;
        }
      }
      &-area6 {
        @include bp(tablet) {
          background-image: url("../assets/img/en/btn_showcase2nd_m_en_6.png") !important;
        }
      }
    }
    &__drag {
      &-info {
        @include bg($bg: "../assets/img/en/drag-info-en.png");
        @include bp(tablet) {
          @include bg($bg: "../assets/img/en/drag-info-en-m.png");
        }
      }
    }
  }
}
:lang(ja) {
  .showcase2nd {
    &__txt {
      &-tit {
        @include bg($bg: "../assets/img/ja/showcase2nd_tit_ja.png");
        @include bp(tablet) {
          @include bg($bg: "../assets/img/ja/showcase2nd_tit_ja_m.png");
        }
      }
      &-desc {
        @include bp(tablet) {
          top: 205px;
        }
      }
    }
    &__btns {
      a {
        @include bp(tablet) {
          width: 315px !important;
          height: 270px !important;
        }

        @include bg($bg: "../assets/img/ja/btn_showcase2nd_pc_ja.png");

        &:before {
          width: 270px;
          @include bg($bg: "../assets/img/ja/btn_showcase2nd_pc_ja.png");
        }
      }
      &-area1 {
        @include bp(tablet) {
          background-image: url("../assets/img/ja/btn_showcase2nd_m_ja_1.png") !important;
        }
        &::before {
          background-position: -238px 9px !important;
        }
      }
      &-area2 {
        @include bp(tablet) {
          background-image: url("../assets/img/ja/btn_showcase2nd_m_ja_2.png") !important;
        }

        &::before {
          background-position: -240px -232px !important;
        }
      }
      &-area3 {
        @include bp(tablet) {
          background-image: url("../assets/img/ja/btn_showcase2nd_m_ja_3.png") !important;
        }

        &::before {
          background-position: -235px -471px !important;
        }
      }
      &-area4 {
        @include bp(tablet) {
          background-image: url("../assets/img/ja/btn_showcase2nd_m_ja_4.png") !important;
        }

        &::before {
          background-position: -238px -692px !important;
        }
      }
      &-area5 {
        @include bp(tablet) {
          background-image: url("../assets/img/ja/btn_showcase2nd_m_ja_5.png") !important;
        }

        &::before {
          background-position: -238px -913px !important;
        }
      }
      &-area6 {
        @include bp(tablet) {
          background-image: url("../assets/img/ja/btn_showcase2nd_m_ja_6.png") !important;
        }
      }
    }
    &__drag {
      &-info {
        @include bg($bg: "../assets/img/ja/drag-info-ja.png");
        @include bp(tablet) {
          @include bg($bg: "../assets/img/ja/drag-info-ja-m.png");
        }
      }
    }
  }
}
:lang(zh) {
  .showcase2nd {
    &__txt {
      &-tit {
        @include bg($bg: "../assets/img/zh/showcase2nd_tit_zh.png");
        @include bp(tablet) {
          @include bg($bg: "../assets/img/zh/showcase2nd_tit_zh_m.png");
        }
      }
    }
    &__btns {
      a {
        @include bg($bg: "../assets/img/zh/btn_showcase2nd_pc_zh.png");

        &:before {
          @include bg($bg: "../assets/img/zh/btn_showcase2nd_pc_zh.png");
        }
      }
      &-area1 {
        @include bp(tablet) {
          background-image: url("../assets/img/zh/btn_showcase2nd_m_zh_1.png") !important;
        }

        &::before {
          background-position: -236px 8px !important;
        }
      }
      &-area2 {
        @include bp(tablet) {
          background-image: url("../assets/img/zh/btn_showcase2nd_m_zh_2.png") !important;
        }
        &::before {
          background-position: -236px -232px !important;
        }
      }
      &-area3 {
        @include bp(tablet) {
          background-image: url("../assets/img/zh/btn_showcase2nd_m_zh_3.png") !important;
        }
        &::before {
          background-position: -236px -474px !important;
        }
      }
      &-area4 {
        @include bp(tablet) {
          background-image: url("../assets/img/zh/btn_showcase2nd_m_zh_4.png") !important;
        }
        &::before {
          background-position: -236px -690px !important;
        }
      }
      &-area5 {
        @include bp(tablet) {
          background-image: url("../assets/img/zh/btn_showcase2nd_m_zh_5.png") !important;
        }
        &::before {
          background-position: -236px -912px !important;
        }
      }
      &-area6 {
        @include bp(tablet) {
          background-image: url("../assets/img/zh/btn_showcase2nd_m_zh_6.png") !important;
        }
      }
    }
    &__drag {
      &-info {
        @include bg($bg: "../assets/img/zh/drag-info-zh.png");
        @include bp(tablet) {
          @include bg($bg: "../assets/img/zh/drag-info-zh-m.png");
        }
      }
    }
  }
}

.youtube-title {
  width: 1000px;
  height: 150px;
  position: absolute;
  left: 50%;
  margin-left: -500px;
  top: -55px;
  font-size: 20px;
  color: #c5ab7c;
  opacity: 0;
  @include bp(tablet) {
    font-size: 13px !important;
    top: -37px !important;
    width: 300px !important;
    margin-left: -150px !important;
  }
}
.showcase2nd {
  background-size: contain;
  &__bg {
    @include position($width: 100%, $height: 100%);
    overflow: hidden;
    &-view {
      // @include bg($bg: "../assets/img/showcase2nd_guide_m.png", $cover: cover);
      @include position(
        $position: absolute,
        $top: 0,
        $left: 0,
        $width: 100%,
        $height: 100%
      );
      // @include bg($bg: '../img/clip_bg.png', $cover: cover);
      video {
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      // @include bg($bg: "../assets/img/showcase2nd_bg.png", $cover: cover);
    }
  }
  &__btns {
    position: absolute;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 11;
    display: none;
    a {
      width: 225px;
      height: 230px;
      @include bg($bg: "../assets/img/ko/btn_showcase2nd_pc_ko.png");
      position: absolute;
      top: 50%;
      left: 50%;
      @include hide-text;
      @include bp(tablet) {
        background-position: center center !important;
        height: 270px !important;
        width: 266px !important;
      }
      &:before {
        @include bp(tablet) {
          display: none;
        }
        opacity: 0;
        display: inline-block;
        content: "";
        @include bg($bg: "../assets/img/ko/btn_showcase2nd_pc_ko.png");
        @include position(
          $position: absolute,
          $width: 233px,
          $height: 230px,
          $top: 0,
          $left: 0
        );
        transition: 0.4s;
      }
      &:hover:before {
        opacity: 1;
      }
    }
    &-area1 {
      @include bp(tablet) {
        background-image: url("../assets/img/ko/btn_showcase2nd_m_ko_1.png") !important;
        margin-left: -36% !important;
        margin-top: -16% !important;
      }
      background-position: 6px 5px !important;
      margin-top: -17%;
      margin-left: -34%;
      &::before {
        background-position: -238px 10px !important;
      }
    }
    &-area2 {
      @include bp(tablet) {
        background-image: url("../assets/img/ko/btn_showcase2nd_m_ko_2.png") !important;
        margin-left: -7% !important;
        margin-top: 102px !important;

      }
      background-position: 6px -235px !important;
      margin-top: 8.5%;
      margin-left: -9%;
      &::before {
        background-position: -238px -233px !important;
      }
    }
    &-area3 {
      @include bp(tablet) {
        background-image: url("../assets/img/ko/btn_showcase2nd_m_ko_3.png") !important;
        margin-left: 3% !important;
        margin-top: -11% !important;
      }
      background-position: 6px -474px !important;
      margin-top: -11%;
      margin-left: 3%;
      &::before {
        background-position: -235px -474px !important;
      }
    }
    &-area4 {
      @include bp(tablet) {
        background-image: url("../assets/img/ko/btn_showcase2nd_m_ko_4.png") !important;
        margin-left: 9% !important;
        margin-top: 4% !important;
      }
      background-position: 6px -695px !important;
      margin-top: 4%;
      margin-left: 7%;
      &::before {
        background-position: -238px -692px !important;
      }
    }
    &-area5 {
      @include bp(tablet) {
        background-image: url("../assets/img/ko/btn_showcase2nd_m_ko_5.png") !important;
        margin-left: 25% !important;
        margin-top: 14% !important;
      }
      background-position: 6px -915px !important;
      margin-top: 14%;
      margin-left: 27%;
      &::before {
        background-position: -238px -912px !important;
      }
    }
    &-area6 {
      @include bp(tablet) {
        background-image: url("../assets/img/ko/btn_showcase2nd_m_ko_6.png") !important;
        margin-left: -26% !important;
        margin-top: 5% !important;
      }
      background-position: 6px -1116px !important;
      margin-top: 3%;
      margin-left: -27%;
      &::before {
        background-position: -238px -1114px !important;
      }
    }
  }
  &__contents {
    @include position($position: absolute, $top: 0%, $left: 50%);
    width: 100%;
    pointer-events: none;
  }
  &__txt {
    @include position(
      $position: absolute,
      $width: 100%,
      $height: 563px,
      $top: 24px,
      $left: 50%
    );

    @include bp(tablet) {
      &-subbg {
        display: block;
        content: "";
        @include bg($bg: "../assets/img/tit_bg_showcase.png", $position: 50% 0);
        background-size: cover;
        width: 326px;
        height: 144px;
        margin-left: -163px;
        position: absolute;
        left: 50%;
        top: 131px;
      }
    }
    &-bg {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $top: 0,
        $left: 50%
      );
      @include bg($bg: "../assets/img/tit_bg.png", $position: 50% 0);
      transform-origin: 50% 180px;
      transform: scale(0.8);
      @include bp(tablet) {
        display: none;
      }
    }
    margin-top: -70px;
    &-bl {
      @include bp(tablet) {
        display: none;
      }
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 34px,
        $top: 157px,
        $left: 50%
      );
      > span {
        display: block;
        @include position(
          $position: absolute,
          $width: 34px,
          $height: 34px,
          $top: 0,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_b.png");
        &:nth-child(1) {
          background-position-x: 0;
        }
        &:nth-child(2) {
          background-position-x: -34px;
        }
        &:nth-child(3) {
          background-position-x: -68px;
        }
      }
      > hr {
        border: none;
        @include position(
          $position: absolute,
          $width: 96px,
          $height: 14px,
          $top: 2px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_l.png");
        margin-left: 17px;
        &:last-child {
          @include bg($bg: "../assets/img/tit_icon_r.png");
          margin-left: -113px;
        }
      }
    }
    &-tit {
      @include bg($bg: "../assets/img/ko/showcase2nd_tit_ko.png");
      @include bp(tablet) {
        width: (620px / 2);
        height: (269px / 2);
        top: 80px;
        margin-left: -148px;
        @include bg($bg: "../assets/img/ko/showcase2nd_tit_ko_m.png");
        background-size: contain;
      }
      @include position(
        $position: absolute,
        $width: 1180px,
        $height: 115px,
        $top: 215px,
        $left: 50%
      );
      margin-left: -590px;
      @include hide-text;
    }
    &-desc {
      @include bp(tablet) {
        font-size: 13px;
        top: 190px;
      }
      @include position(
        $position: absolute,
        $width: 100%,
        $top: 317px,
        $left: 50%
      );
      font-size: 19px;
      text-align: center;
      letter-spacing: -0.9px;
      line-height: 1.8em;
      opacity: 0.4;
      .zh &,
      .en & {
        letter-spacing: 0px;
      }
    }
  }

  &__drag {
    &-info {
      z-index: 11;
      width: 517px;
      height: 310px;
      @include position($position: absolute, $top: 50%, $left: 50%);
      @include bg($bg: "../assets/img/ko/drag-info-ko.png");
      @include bp(tablet) {
        width: (572px / 2);
        height: (349px / 2);
        @include bg($bg: "../assets/img/ko/drag-info-ko-m.png");
        background-size: auto 100%;
      }
      @include hide-text;
      opacity: 1;
    }
  }

  @include bp(tablet) {
    &__bg {
      &-view {
        min-width: auto;
        //  width: 1100px;
        video {
          min-width: auto;
          height: 100%;
        }
      }
    }
    &__btns {
      a {
        transform-origin: 0% 0%;
        transform: scale(0.5);
      }
    }
  }
}

.showcase-layer {
  .promokit-layer__contents {
    margin-top: 50px;
    max-width: 1426px !important;

    @media (max-width: 1400px) {
      max-width: 1366px !important;
    }

    @media (max-width: 1300px) {
      max-width: 1280px !important;
    }

    @media (max-width: 1200px) {
      max-width: 1024px !important;
    }

    @include bp(tablet) {
      margin-top: 0;
      max-width: auto !important;
    }

    .promokit-youtube {
      height: 851px !important;

      @media (max-width: 1400px) {
        height: 768px !important;
      }

      @media (max-width: 1300px) {
        height: 720px !important;
      }

      @media (max-width: 1200px) {
        height: 576px !important;
      }
      @include bp(tablet) {
        height: 360px !important;
      }
      @include bp(mobile) {
        height: 56.3vw !important;
      }

      &__screen-wrap {
        width: 100% !important;
        height: 100% !important;
      }
    }
    .slick-arrow {
      @include bp(tablet) {
        display: none;
      }
      left: 50% !important;
      &.slick-prev {
        margin-left: -805px !important;
      }
      &.slick-next {
        margin-left: 731px !important;
      }
    }
    .slick-dots {
      margin-top: 30px;
      @include bp(tablet) {
        margin-top: 0;
      }
      button {
        width: 14px !important;
        height: 14px !important;
        background-size: 100% auto !important;
      }
      .slick-active {
        button {
          background-position-y: -14px;
        }
      }
    }

    @include bp(tablet) {
      .slick-dots {
        bottom: -10%;
      }
    }
    .promokit-youtube__bg::after {
      right: 0 !important;
      z-index: 4 !important;
      @include bp(tablet) {
        display: none;
      }
    }
    .promokit-youtube__bg::before {
      left: 0 !important;
      z-index: 4 !important;
      @include bp(tablet) {
        display: none;
      }
    }
  }
  .promokit-layer__close {
    margin-left: 744px !important;
    margin-top: -425px !important;
    @media (max-width: 1500px) {
      width: 25px;
      height: 25px;
      top: 25px;
      right: 25px !important;
      transform: translateX(-50%);
      margin-left: auto !important;
      margin-top: auto !important;
    }

    @media (max-width: tablet) {
      right: 15px !important;
    }
  }
}
</style>
